import { useTranslation } from 'react-i18next';
import { Toast } from '@pletly/ui';

import { getName } from '@pletly/shared';
import { useUser } from '%hooks';
import { useNewInvitationSubscription as useNewInvitationSubscriptionHook } from './__generated__/newInvitation.subscription.generated';

export const useNewInvitationSubscription = (onDataReceived?: () => void) => {
	const { t } = useTranslation();
	const user = useUser();
	useNewInvitationSubscriptionHook({
		variables: { userId: user.id.toString() },
		onData: ({ data: { data } }) => {
			if (!data?.inviteAdded) return;

			const { email, ...userInfo } = data.inviteAdded.fromUser;
			const notificationText = t('connections.who-sent-invite', {
				who: getName(userInfo) || email,
			});
			displayNotification(t('connections.new-invitation'), notificationText);

			onDataReceived?.();
		},
	});
};

const displayNotification = (title: string, text: string) =>
	Toast.show({
		type: 'success',
		text1: title,
		text2: text,
	});
